import React, { FC, useState, useEffect, useContext } from 'react'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import 'moment/locale/pl' // without this line it didn't work

import AppContext from '../../../context/appContext'

import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericButton from '../../../GenericComponents/GenericButton'
import {
  UserGoalButtonBox,
  UserGoalOption,
} from '../../CalculatorScreen/style/CalculatorStyles'

import ArrowRight from '../../../assets/REDESIGN_Assets/Diet/arrow-right.svg'

import ProgressChart from './ProgressChart'

interface MainViewInterface {
  handleChangeProgressMode: Function
  clickedFeedData: any
  feeds: any
  progressMode: any
  updateClickedData: Function
  setAddEntryMode: Function
  handleGoToShowcase: Function
}

const MainView: FC<MainViewInterface> = ({
  handleChangeProgressMode,
  clickedFeedData,
  feeds,
  progressMode,
  updateClickedData,
  setAddEntryMode,
  handleGoToShowcase,
}) => {
  const appContext = useContext(AppContext)
  moment.locale('pl')

  return (
    <GenericMainCard
      width={isMobile ? '95%' : '60%'}
      flexDir={'column'}
      className="standard"
      margin={isMobile ? '0% auto 0 auto' : '5% auto 0 auto'}
    >
      <GenericTextSpan margin={isMobile ? '5% 0' : 'unset'} fSize={'1.8rem'}>
        Twoje postępy
      </GenericTextSpan>
      <UserGoalButtonBox className="progress-option">
        <UserGoalOption
          className={'goal-option active '}
          onClick={(e: any) => handleChangeProgressMode(e)}
          id={1}
        >
          Brzuch
        </UserGoalOption>
        <UserGoalOption
          className={'goal-option'}
          onClick={(e: any) => handleChangeProgressMode(e)}
          id={2}
        >
          Biodra
        </UserGoalOption>
        <UserGoalOption
          className={'goal-option'}
          onClick={(e: any) => handleChangeProgressMode(e)}
          id={3}
        >
          Udo
        </UserGoalOption>
      </UserGoalButtonBox>

      <GenericRow
        margin={isMobile ? '4% 0' : '2% 0 0 0'}
        justify="center"
        width={isMobile ? '80%' : window.innerWidth / 2.93 + 'px'}
      >
        {clickedFeedData && clickedFeedData.dimensionNumber != undefined ? (
          <GenericTextSpan>
            {'Pomiar ' + clickedFeedData.dimensionNumber}
          </GenericTextSpan>
        ) : (
          ''
        )}
      </GenericRow>

      <GenericRow
        margin={'2% 0 0 0'}
        justify="flex-start"
        fSize={'1.4rem'}
        width={isMobile ? '80%' : window.innerWidth / 2.93 + 'px'}
      >
        {clickedFeedData && clickedFeedData.date ? (
          <GenericTextSpan>
            {moment(clickedFeedData.date).format('D MMMM YYYY')}
          </GenericTextSpan>
        ) : (
          <GenericTextSpan>{`  `}</GenericTextSpan>
        )}
      </GenericRow>

      {clickedFeedData && clickedFeedData.type ? (
        <GenericRow
          margin={'1% 0 0 0'}
          justify="space-between"
          width={isMobile ? '80%' : window.innerWidth / 2.93 + 'px'}
        >
          <GenericRow justify="flex-start" width={'100%'}>
            <GenericTextSpan fSize={'1.4rem'}>
              {clickedFeedData.type}:{' '}
            </GenericTextSpan>
            <GenericTextSpan
              fSize={'1.4rem'}
              fWeight={'bold'}
              margin={'0 0 0 5%'}
            >
              {' '}
              {clickedFeedData.value} cm
            </GenericTextSpan>
          </GenericRow>
          <GenericRow
            justify="flex-end"
            width={isMobile ? '80%' : window.innerWidth / 2.93 + 'px'}
          >
            <GenericTextSpan
              fSize={'1.4rem'}
              onClick={handleGoToShowcase}
              className="color-green button-style"
            >
              Szczegóły{' '}
            </GenericTextSpan>
            <GenericIcon
              margin={'0 0 0 5%'}
              src={ArrowRight}
              width={isMobile ? '2.5vw' : '0.9vw'}
              height={isMobile ? '2.5vw' : '0.7vw'}
            />
          </GenericRow>
        </GenericRow>
      ) : (
        <GenericRow margin={'0% 0 0 0'}> </GenericRow>
      )}

      <ProgressChart
        feeds={feeds}
        progressMode={progressMode}
        // setClickedFeedData={setClickedFeedData}
        updateClickedData={updateClickedData}
      />
      {((feeds &&
        feeds[feeds.length - 1] &&
        !moment(feeds[feeds.length - 1].creation_datetime).isSame(
          moment(),
          'day'
        )) ||
        feeds.length == 0) && (
        <GenericButton
          className="standard"
          justify={'center'}
          width={isMobile ? '80%' : '40%'}
          onClick={() => setAddEntryMode()}
        >
          Dodaj nowy pomiar
        </GenericButton>
      )}
    </GenericMainCard>
  )
}

export default MainView
